import { VideoJsPlayer } from 'video.js';
import { useEffect, useState } from 'react';
import { timeToSeconds } from '../PlayerServices';
import { ActionBarBtn } from '../styles';
import { __t } from '../../../i18n';
import UsePlayerProps from '../../../Store/usePlayerProps';
import IconSkipNext from '../../../icons/IconSkipNext';

export default function SkipIntro({ player }: { player: VideoJsPlayer }) {
  const contentConfigs = UsePlayerProps((state) => state.playerState.contentConfigs);

  const firstTitration = contentConfigs?.titrations?.find((item) => item?.video_file_titrations_type === 'start');
  const [showFirstTitration, setShowFirstTitration] = useState<boolean>(false);
  useEffect(() => {
    const handleProgress = () => {
      firstTitration && setShowFirstTitration(timeToSeconds(firstTitration.start_time) < player.currentTime() &&
        player.currentTime() < timeToSeconds(firstTitration.end_time));
    };

    // 'timeupdate', not 'progress': with VHS, 'progress' only fires as the buffer grows, about
    // once a segment, so the button came late and stayed past the intro.
    player.on('timeupdate', handleProgress);
    return () => {
      player.off('timeupdate', handleProgress);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [player]);
  const handleSkipIntro = () => {
    if (showFirstTitration) {
      player.currentTime(timeToSeconds(firstTitration?.end_time));
      setShowFirstTitration(false);
    }
  };

  return (
    <>
      {showFirstTitration && <ActionBarBtn onClick={handleSkipIntro}>
        {__t('player.skip_intro')}
        <IconSkipNext />
      </ActionBarBtn>}
    </>
  );
}
